import Vue from "vue";
import router from "@/router";

function sortByName(arr) {
  if (!arr || !arr.length) return arr;
  return [...arr].sort((a, b) => {
    const nameA = (a.name || a || "").toString().toLowerCase();
    const nameB = (b.name || b || "").toString().toLowerCase();
    return nameA.localeCompare(nameB, "de");
  });
}

const MAPPING = state => {
  return {
    BOOK: state.books,
    BOOK_PACKAGE: state.bookPackages,
    CHAPTER: state.chapters,
    COMPETENCE_MODULE: state.competenceModules,
    SCHOOL_SUBJECT: state.schoolSubjects,
    SCHOOL_TYPE: state.schoolTypes,
    SKILL: state.skills,
    TASK: state.tasks,
    TASK_TYPE: state.taskTypes,
    TOPIC: state.topics,
    FILTER: state.filter,
    CONTENT_TYPE: state.contentTypes
  };
};

export default {
  BASIC_FILTER_MUTATION(state, filterObj) {
    //Vue.$log.debug("BASIC_FILTER_MUTATION", filterObj);
    Object.assign(state.basicFilter, filterObj);
  },
  CHANGE_CURRENT_ENTITY_MUTATION(state, pair) {
    Vue.$log.debug("CHANGE_CURRENT_ENTITY_MUTATION", pair);
    const type = pair.type;
    const entity = pair.entity;
    state.current[type] = Object.assign(state.current[type], entity);
  },
  CHANGE_CURRENT_ASSIGNMENT_MUTATION(state, event) {
    const mapping = MAPPING(state);
    const member = event.member;
    const foreignType = event.foreignType;
    const foreignArray = mapping[foreignType];
    if (!foreignArray || !foreignArray.length) {
      return;
    }
    const entity = event.entity;
    for (const e of foreignArray) {
      for (const a of event.assigned) {
        if (e.id === a.id) {
          if (!e[member]) { e[member] = []; }
          e[member].push(entity);
        }
      }
      for (const r of event.removed) {
        if (e.id === r.id && e[member]) {
          e[member] = e[member].filter(m => m.id !== entity.id);
        }
      }
    }
  },
  CHANGE_CURRENT_TASK_FILTER(state, obj) {
    Object.assign(state.taskFilter, obj);
    router.push({ query: state.taskFilter });
  },
  DASHBOARD_MUTATION(state, data) {
    state.books = sortByName(data.books || []);
    state.bookPackages = sortByName(data.bookPackages || []);
    state.chapters = sortByName(data.chapters || []);
    state.competenceModules = sortByName(data.competenceModules || []);
    state.schoolSubjects = sortByName(data.schoolSubjects || []);
    state.schoolTypes = sortByName(data.schoolTypes || []);
    state.skills = sortByName(data.skills || []);
    state.taskTypes = sortByName(data.taskTypes || []);
    state.topics = sortByName(data.topics || []);
    state.filter = sortByName(data.filter || []);
    state.contentTypes = sortByName(data.contentTypes || []);

    state.tasks = data.tasks || [];
    state.names.taskNames = data.taskNames || [];
    state.names.taskTypeNames = data.taskTypeNames || [];
    state.names.skillNames = data.skillNames || [];
    state.names.chapterNames = data.chapterNames || [];
    state.names.bookPackageNames = data.bookPackageNames || [];
    state.names.topicNames = data.topicNames || [];
    state.names.bookNames = data.bookNames || [];
    state.names.schoolTypeNames = data.schoolTypeNames || [];
    state.meta.taskCount = data.taskCount || 0;
    state.meta.taskPages = data.taskPages || 1;
    state.taskCurrentPage = 1;
    state.hasMoreTasks = 1 < (data.taskPages || 1);
    state.loadingMoreTasks = false;

    Vue.$log.debug("DASHBOARD_MUTATION", state);
  },
  UPDATE_TASKS_FROM_DASHBOARD(state, data) {
    state.tasks = data.tasks || [];
    state.names.taskNames = data.taskNames || [];
    state.names.taskTypeNames = data.taskTypeNames || [];
    state.names.skillNames = data.skillNames || [];
    state.names.chapterNames = data.chapterNames || [];
    state.names.bookPackageNames = data.bookPackageNames || [];
    state.names.topicNames = data.topicNames || [];
    state.names.bookNames = data.bookNames || [];
    state.names.schoolTypeNames = data.schoolTypeNames || [];
    state.meta.taskCount = data.taskCount || 0;
    state.meta.taskPages = data.taskPages || 1;
    state.taskCurrentPage = 1;
    state.hasMoreTasks = 1 < (data.taskPages || 1);
    state.loadingMoreTasks = false;
  },
  APPEND_TASKS_FROM_DASHBOARD(state, data) {
    const newTasks = data.tasks || [];
    state.tasks = state.tasks.concat(newTasks);
    state.taskCurrentPage = state.taskCurrentPage + 1;
    state.meta.taskCount = data.taskCount || state.meta.taskCount;
    state.meta.taskPages = data.taskPages || state.meta.taskPages;
    state.hasMoreTasks = state.taskCurrentPage < (data.taskPages || 1);
    state.loadingMoreTasks = false;
  },
  SET_LOADING_MORE_TASKS(state, loading) {
    state.loadingMoreTasks = loading;
  },
  SET_DEPLOYMENT_RESULTS(state, results) {
    state.deploymentResults = results;
  },
  SET_FAQS(state, faqs) {
    state.faqs = faqs;
  }
};
